import React from 'react';
import PropTypes from 'prop-types';

import {View} from 'react-native';
import { pure } from '@dbk/ui-react-utils';

import CalendarWeek from './calendar-week';
import CalendarMonthHeader from './calendar-month-header';
import styles from './calendar.styles';

function CalendarMonth(props) {
  const {
    highlightDays,
    fromDate,
    toDate,
    minDate,
    maxDate,
    name,
    weekdayNames,
    date,
    onSelectDate,
    languageCode,
    messages
  } = props;

  const month = date.getMonth();
  const year = date.getFullYear();

  const weeks = createWeeks(date, month);

  return (<div className="calendar-month">
    <CalendarMonthHeader name={name} year={year} weekdayNames={weekdayNames} languageCode={languageCode} messages={messages}/>
    {weeks.map((weekStart, index) => (<CalendarWeek
      start={weekStart}
      fromDate={fromDate}
      toDate={toDate}
      minDate={minDate}
      maxDate={maxDate}
      month={month}
      key={`week-${index}`}
      highlightDays={highlightDays}
      onSelectDate={onSelectDate}
    />))}
  </div>);
}

CalendarMonth.propTypes = {
  date: PropTypes.instanceOf(Date),
  fromDate: CalendarWeek.propTypes.fromDate,
  toDate: CalendarWeek.propTypes.toDate,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date).isRequired,
  name: PropTypes.string,
  weekdayNames: CalendarMonthHeader.propTypes.weekdayNames,
  highlightDays: CalendarWeek.propTypes.highlightDays,
  onSelectDate: CalendarWeek.propTypes.onSelectDate,
};

export default pure(CalendarMonth);

function createWeeks(date, month) {
  const weeks = [];
  const monthEnd = new Date(Date.UTC(date.getFullYear(), month + 1, 1, -1));

  date.setDate(date.getDate() - date.getDay());

  while (date < monthEnd) {
    weeks.push(new Date(date));

    date.setDate(date.getDate() + 7);
  }

  return weeks;
}
